import { Box, Typography } from "@mui/material";
import { SeeMoreContent } from "../../../../components/SeeMoreContent";

export default function VulnerabilitiesHeader({ selectedVulnerability }) {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box
        display={"flex"}
        flexDirection={"row"}
        gap={1}
        justifyContent={"flex-start"}
      >
        <Typography variant="h5">
          {selectedVulnerability?.vulnerability_id}
        </Typography>
      </Box>
      <Box overflow="hidden" mt={1}>
        {selectedVulnerability?.cisa_name && (
          <Typography variant="subtitle2">
            {selectedVulnerability.cisa_name}
          </Typography>
        )}
        <SeeMoreContent
          content={selectedVulnerability?.description?.replace(/`/g, "")}
          initialCharCount={130}
          lineHeight={1.4}
          variant="body2"
        />
      </Box>
    </Box>
  );
}
